"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingItemTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
exports.SettingItemTitle = (0, react_1.memo)(({ title, description, sx }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", padding: 2, sx: sx, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", noWrap: true, color: "text.primary", fontWeight: "bold", children: title }), description && ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "text.secondary", textOverflow: "ellipsis", sx: {
                    WebkitLineClamp: 2,
                }, children: description }))] }));
});
exports.SettingItemTitle.displayName = "SettingItemTitle";
